import { useEffect, useRef } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import HomeAbout from "./HomeAbout";
import HomeWhatIs from "./HomeWhatIs";
import HomeEcoSystem from "./HomeEcoSystem";
import HomeCoinIntro from "./HomeCoinIntro/HomeCoinIntro";
import HomeBannerLt from "./HomeBannerLt";
import HomeRouTech from "./HomeRouTech";
import HomeTeam from "./HomeTeam";
import HomeTokenomics from "./HomeTokenomics";
import Faq from "./Faq/Faq";
import RoadMap from "./RoadMap/RoadMap";

const Home = () => {

   const loader = useRef();

   useEffect(() => {
      setInterval(() => {
         loader.current?.classList.add('d-none')
      }, [500])
   }, [])



   return (
      <>
         <Header />

         <div ref={loader} id="loader">
            <div className="loadercls">
               <div className="spin" id="Spin1"></div>
               <div className="spin" id="Spin2"></div>
               <div className="spin" id="Spin3"></div>
               <div className="spin" id="Spin4"></div>
               <span id="textloading">LOADING...</span>
               <br />
            </div>
         </div>

         <HomeBannerLt />

         <main className="SecCmnBg23">
            <HomeAbout />
            <HomeWhatIs />
         </main>

         <HomeTokenomics />

         <HomeEcoSystem />

         <HomeCoinIntro />

         <RoadMap />

         <HomeTeam />        

         <HomeRouTech />         

         <Faq />

         <Footer />

      </>
   )
}
export default Home;